import {
  ICustomer,
  ILocation,
  IProductCreateResponse,
} from '@boma/supplier-portal/shared/entities';
import { IEntityUser, IUserAccount } from '@boma/client-shared';
import { Nullable } from '@boma/shared/entities';

export interface IPricingGroup {
  validFrom: string;
  validUntil: string;
  id: string;
  entity: IEntityUser;
  name: string;
  deletedAt: string;
  items: ILocationProductPricingTier[];
  customers: ICustomer[];
}

export interface IPricingAuditEntry {
  id: string;
  oldPrice: number;
  updatedPrice: number;
  createdAt: string;
  location: any;
  customerLocation: any;
  pricingGroupId: string;
  pricingGroupName: string;
  product: {
    id: string;
    name: string;
  };
  user: {
    id: string;
    firstName: string;
    surname: string;
  };
}

export interface IPricingGroupByProduct {
  id: string;
  entity: IEntityUser;
  name: string;
  productLocationPricingTiers: {
    product: IProductCreateResponse;
    locationPricing: ILocationPricingTierDetails[];
  }[];
  customers: ICustomer[];
}

export interface IPricingGroupByLocation {
  id: string;
  entity: IEntityUser;
  name: string;
  locationProductPricingTiers: {
    product: IProductCreateResponse;
    locationPricing: ILocationPricingTierDetails[];
  }[];
  customers: ICustomer[];
}

export interface ILocationPricingTierDetails {
  location: ILocation;
  details: ILocationProductDetails[];
}

export interface ILocationProductDetails {
  locationId: string;
  productId: string;
  price: number;
  lastUpdatedBy: IUserAccount;
  minimumOrderQuantity: number;
  maximumOrderQuantity: Nullable<number>;
  specialInstructions: Nullable<string>;
  acceptCashOnDelivery: boolean;
  acceptBankTransfers: boolean;
  enforceStockChecks: boolean;
  confirmAllOrders: boolean;
  validFrom: Nullable<string>;
  validUntil: Nullable<string>;
}

export interface ILocationProductPricingTier {
  id: string;
  name: string;
  product: IProductCreateResponse;
  location: ILocation;
  //Who created this pricing tier
  user: IUserAccount;
  price: number;
  lastUpdatedBy: IUserAccount;
  minimumOrderQuantity: number;
  maximumOrderQuantity: number;
  specialInstructions: string;
  acceptCashOnDelivery: boolean;
  acceptBankTransfers: boolean;
  enforceStockChecks: boolean;
  confirmAllOrders: boolean;
  validFrom: string;
  validUntil: string;
}

// TODO expand this
export interface IPricingBulkCustomer {
  customer: ICustomer;
  productPricingTiers: any;
}
